import { QBankStructureStatus, QBankStructureType } from '@exam-management/graphql';
import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import {
  parseAsArrayOf,
  parseAsInteger,
  parseAsString,
  parseAsStringEnum,
  parseAsStringLiteral,
  useQueryStates,
} from 'nuqs';

export function useQBankStructureSearchParams() {
  return useQueryStates(
    {
      search: parseAsString.withDefault(''),
      page: parseAsPageNumber.withDefault(0),
      pageSize: parseAsInteger.withDefault(10),
      field: parseAsString.withDefault('updatedAt'),
      sort: parseAsStringLiteral(dataGridSortDirection).withDefault('desc'),
      statuses: parseAsArrayOf(
        parseAsStringEnum<QBankStructureStatus>(Object.values(QBankStructureStatus)),
      ).withDefault([]),
      types: parseAsArrayOf(
        parseAsStringEnum<QBankStructureType>(Object.values(QBankStructureType)),
      ).withDefault([]),
      group: parseAsString.withDefault(''),
    },
    {
      urlKeys: {
        search: 'q',
      },
    },
  );
}
